import { render, staticRenderFns } from "./BtnActivity.vue?vue&type=template&id=c8180882&"
import script from "./BtnActivity.vue?vue&type=script&lang=js&"
export * from "./BtnActivity.vue?vue&type=script&lang=js&"
import style0 from "./BtnActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports